import React from 'react';
import PropTypes from 'prop-types';

import './index.less';

/**
 * antd 4 Comment 兼容组件。
 *
 * antd 5 移除了 Comment，此组件按 antd 4 的核心结构重写：
 * avatar + author/datetime + content + actions + 嵌套 children。
 */
export default function Comment({
    actions,
    author,
    avatar,
    children,
    content,
    datetime,
    className,
    style,
    ...rest
}) {
    return (
        <div className={`bi-comment ${className || ''}`} style={style} {...rest}>
            <div className="bi-comment-inner">
                {avatar && <div className="bi-comment-avatar">{avatar}</div>}
                <div className="bi-comment-content">
                    {(author || datetime) && (
                        <div className="bi-comment-content-author">
                            {author && (
                                <span className="bi-comment-content-author-name">{author}</span>
                            )}
                            {datetime && (
                                <span className="bi-comment-content-author-time">{datetime}</span>
                            )}
                        </div>
                    )}
                    {content && <div className="bi-comment-content-detail">{content}</div>}
                    {actions && actions.length > 0 && (
                        <ul className="bi-comment-actions">
                            {actions.map((action, index) => (
                                <li key={index}>{action}</li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
            {children && <div className="bi-comment-nested">{children}</div>}
        </div>
    );
}

Comment.propTypes = {
    actions: PropTypes.array,
    author: PropTypes.node,
    avatar: PropTypes.node,
    children: PropTypes.node,
    content: PropTypes.node,
    datetime: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
};
